export default __webpack_public_path__ + "static/media/text_start.be577cf5.png";